import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FocusTrapModule } from 'primeng/focustrap';
import { AutoFocus } from 'primeng/autofocus';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { FluidModule } from 'primeng/fluid';
import { ToastModule } from 'primeng/toast';
import { InputGroupModule } from 'primeng/inputgroup';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { Password } from 'primeng/password';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

@NgModule({
  declarations: [LoginComponent, ForgotPasswordComponent, ResetPasswordComponent],
  imports: [
    RouterModule,
    CommonModule,
    ButtonModule,
    InputTextModule,
    CheckboxModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    MessageModule,
    ToastModule,
    FocusTrapModule,
    AutoFocus,
    FluidModule,
    InputGroupModule,
    IconFieldModule,
    InputIconModule,
    Password,
    ProgressSpinnerModule,
  ],
  exports: [LoginComponent, ForgotPasswordComponent, ResetPasswordComponent],
})
export class AuthModule {}
